export default "__VITE_ASSET__pDM8b1gQ__"